import { useEffect, useState } from 'react'
import { Customer } from '../../model/Customer'
import { ProviderValue, useAxios } from '../../config/axios-config'
import { PageLoader } from '../util/PageLoader'
import { CustomersResponseDTO, PaymentSummaryResponseDTO } from '../../model/ResponsesDTO'
import { Col, Container, Form, InputGroup, Row, Table } from 'react-bootstrap'
import { Pagination, Stack } from '@mui/material';
import { CustomerForPaymentsElement } from './CustomerForPaymentsElement'
import { HeaderSorterColumn } from '../util/HeaderSorterColumn'
import { DinneyObject } from '../../model/DinneyObject'
import { isMobile } from 'react-device-detect';
import './style.css'
import { Empty, SelectProps, Switch } from 'antd'
import { ErrorPage } from '../error/ErrorPage'
import { PaymentSummaryRequestDTO } from '../../model/PaymentSummaryRequestDTO'
import dayjs from 'dayjs'
import { SendToComponent } from '../mealselection/SendToComponent'
import { SendStream } from '../util/SendStream'
import {DinneyUtil} from "../util/DinneyUtil";

export const CustomersForPaymentsPage = () => {

  const axiosInstance = useAxios() as ProviderValue
  const [customersList, setCustomersList] = useState<Customer[]>([])
  const [filteredCustomersList, setFilteredCustomersList] = useState<Customer[]>([])
  const [isLoaded, setIsLoaded] = useState<boolean>(false)
  const [isError, setIsError] = useState<boolean>(false)
  const [filter, setFilter] = useState<string>('')
  const [filterActive, setFilterActive] = useState<boolean>(true)
  const [count, setCount] = useState<number>(0)
  const [page, setPage] = useState<number>(1)
  const [show, setShow] = useState(false);
    const [customerIdsList, setCustomerIdsList] = useState<number[]>([])
  const [options, setOptions] = useState<SelectProps['options']>([]);
  const controller = new AbortController();
  const signal = controller.signal

useEffect(() => {
  axiosInstance.get<CustomersResponseDTO>("/customers/secure/fetch/allforpayments", {signal})
    .then(response => {
      handleSort('position', true, response.data.customersForPayments)
      setIsLoaded(true)
      setIsError(false)
    }).catch((e : any) => {
      setIsLoaded(true)
      setIsError(true)
      console.log(e.response?.data?.message === undefined ? e : e.response?.data?.message)
      }) 
    
      return () => {
        controller.abort()
      }
// eslint-disable-next-line 
},[])

useEffect(() => { },[filter])

const handleFillOptions = (customers : Customer[]) => {
        let tempOptions : SelectProps['options']= []
        customers.forEach(customer => {
            if (customer.email !== "Brak") {
                tempOptions!.push({
                    value: customer.customerid,
                    label: `${customer.firstName} ${customer.lastName}`
                })
            }
        })
        setOptions(tempOptions)
    }

const handleSaveToDatabase = async (paymentSummaryRequestDTO : PaymentSummaryRequestDTO, passedCustomerid : number) => {
  setIsLoaded(false)
  
  await axiosInstance.post<PaymentSummaryResponseDTO>(`/paymentsummaries/secure/update`, paymentSummaryRequestDTO, {signal}).then((response) => {
    let index = customersList.findIndex(customer => customer.customerid === passedCustomerid)
    customersList.at(index)!.paymentSummary = response.data.paymentSummary
    handleSort('position', true, customersList)
      
  }).catch((e) => {
      setIsLoaded(true) 
      setIsError(true)
      console.log(e.response?.data?.message === undefined ? e : e.response?.data?.message)
  })
  setIsLoaded(true) 
  return () => {
    controller.abort()
  }
}

const handleSort = (column : string, descending: boolean, list? : DinneyObject[]) => {
  let listToSort = list as Customer[] === undefined ? customersList : list as Customer[]
  let sortedCustomersList = [...listToSort!].sort((a,b) => {
    switch (column) {
        case 'firstName':
            return DinneyUtil.setOrder(a.firstName.toLowerCase(), b.firstName.toLowerCase(),
                a.customerid, b.customerid, descending)
        case 'childName':
            return DinneyUtil.setOrder(a.childName.toLowerCase(), b.childName.toLowerCase(),
                a.customerid, b.customerid, descending)
        case 'email':
            if (a.email.toLowerCase() < b.email.toLowerCase()) {
                return descending ? -1 : 1
            }
            if (a.email.toLowerCase() > b.email.toLowerCase()) {
                return descending ? 1 : -1
            }
            return DinneyUtil.setOrder(a.email.toLowerCase(), b.email.toLowerCase(),
                a.customerid, b.customerid, descending)
        case 'description':
            return DinneyUtil.setOrder(a.description.toLowerCase(), b.description.toLowerCase(),
                a.customerid, b.customerid, descending)
        case 'position':
            return DinneyUtil.setOrder(a.position, b.position, a.customerid, b.customerid, descending)
        case 'activeStart':
            if (a.activeStart < b.activeStart) {
                return descending ? -1 : 1
            }
            if (a.activeStart > b.activeStart) {
                return descending ? 1 : -1
            }
            return DinneyUtil.setOrder(a.activeStart, b.activeStart,
                a.customerid, b.customerid, descending)
        case 'activeEnd':
            if (a.activeEnd < b.activeEnd) {
                return descending ? -1 : 1
            }
            if (a.activeEnd > b.activeEnd) {
                return descending ? 1 : -1
            }
            return DinneyUtil.setOrder(a.activeEnd, b.activeEnd,
                a.customerid, b.customerid, descending)
        default:
        if (a.lastName.toLowerCase() < b.lastName.toLowerCase() ) {
          return descending ? -1 : 1
        } 
        if (a.lastName.toLowerCase()  > b.lastName.toLowerCase() ) {
          return descending ? 1 : -1
        } 
        return 0
    }
  })
  setCustomersList(sortedCustomersList)
  let tempFilteredCustomersList = sortedCustomersList.filter(customer => customer.active === filterActive)
  handleFillOptions(tempFilteredCustomersList)
  setFilteredCustomersList(tempFilteredCustomersList)
  setCount(Math.ceil(tempFilteredCustomersList.length/10))
}

const handleFilter = (phrase : string) => {
  let tempFilteredCustomersList = customersList.filter(customer => (`${customer.firstName} ${customer.lastName} ${customer.childName}`).toLocaleLowerCase().includes(phrase.toLowerCase()))
  setCount(Math.ceil(tempFilteredCustomersList.length/10))
  setFilteredCustomersList(tempFilteredCustomersList)
  setFilter(phrase)
}

const handleFilterActive = (isActive : boolean) => {
  setPage(1)
  handleFilter('')
  let tempFilteredCustomersList = customersList.filter(customer => customer.active === isActive)
  setCount(Math.ceil(tempFilteredCustomersList.length/10))
  handleFillOptions(tempFilteredCustomersList)
  setFilteredCustomersList(tempFilteredCustomersList)
  setFilterActive(prev => !prev); 
}

  if (!isLoaded) {
      return (
          <PageLoader />
      )
  }

  if (isError) {
        return (
          <ErrorPage />
        )
  }

  return (
    <>
      <Container fluid className={'my-4'}>
        {isMobile ?
        <>
        <Row>
        <InputGroup className="mb-1 p-0">
            <Form.Control
              value={filter}
              size="sm"
              placeholder="Filtruj po imieniu i nazwisku"
              aria-label="Filtruj po imieniu i nazwisku"
              aria-describedby="basic-addon2"
              onChange={(e) => handleFilter(e.target.value)}
            />
          </InputGroup>
          <button className='button-65-mobile mb-2' onClick={() => handleFilter('')}>
              Wyczyść
          </button>
        </Row>
        </>
        :
        <Row>
          <Col>
          </Col>
          <Col className='float-end text-end'>
          <InputGroup className="mb-3">
            <Form.Control
              value={filter}
              placeholder="Filtruj po imieniu i nazwisku rodzica lub dziecka"
              aria-label="Filtruj po imieniu i nazwisku rodzica lub dziecka"
              aria-describedby="basic-addon2"
              onChange={(e) => handleFilter(e.target.value)}
            />
            <button className='button-65' onClick={() => handleFilter('')}>
              Wyczyść
            </button>
          </InputGroup>
          </Col>
        </Row>
        }
        <Row>
          <SendToComponent options={options} 
            filteredCustomersList = {filteredCustomersList} 
            pickedDate={dayjs()} 
            sendStream={SendStream.BILLING}
            customerIdsList={customerIdsList}
            setCustomerIdsList={setCustomerIdsList}
          />
        </Row>
      </Container>
      <Switch
              size = "small"
              checkedChildren="Pokaż aktywnych" 
              unCheckedChildren="Pokaż nieaktywnych"
              checked={filterActive}
              onClick={() => handleFilterActive(!filterActive)}
      />
      <Table striped={filteredCustomersList !== undefined && filteredCustomersList.length > 0 } responsive>
        <thead>
        <tr>
            {isMobile ? <></> : <th>#</th>}
            <th>
                <HeaderSorterColumn columnName={isMobile ? 'Poz.' : 'Pozycja'} sortCondition={'position'}
                                    handleSort={handleSort}/>
            </th>
            <th>
                <HeaderSorterColumn columnName={isMobile ? 'Imię' : 'Imię rodzica'} sortCondition={'firstName'}
                                    handleSort={handleSort}/>
            </th>
            <th>
                <HeaderSorterColumn columnName={isMobile ? 'Nazwisko' : 'Nazwisko rodzica'} sortCondition={'lastName'}
                                    handleSort={handleSort}/>
            </th>
            {isMobile ?
                <></>
                :
                <>
                    <th>
                        <HeaderSorterColumn columnName={'Imię i nazwisko dziecka'} sortCondition={'childName'}
                                            handleSort={handleSort}/>
                    </th>
                </>
            }
            <th className={isMobile ? 'mobile-text-size' : ''}>
                {'Saldo bieżące'}
            </th>
            <th className={isMobile ? 'mobile-text-size' : ''}>
                {'Saldo'}
            </th>
            <th className={isMobile ? 'mobile-text-size' : ''}>
                {'Wpłaty'}
            </th>
            <th className={isMobile ? 'mobile-text-size' : ''}>{'Akcje'}</th>
        </tr>
        </thead>
          <tbody>
          {filteredCustomersList !== undefined && filteredCustomersList.length > 0
              ?
              filteredCustomersList
                  .filter((customer : Customer, index : number) => {return index >= (page*10)-10 && index < page*10 && customer.active === filterActive})
            .map((customer : Customer, index : number) => (
              <CustomerForPaymentsElement key={index} 
              customer={customer} 
              show={show} 
              setShow={setShow} 
              index={index} 
              handleSaveToDatabase={handleSaveToDatabase}
              page={page}
              customerIdsList={customerIdsList}
              setCustomerIdsList={setCustomerIdsList}/>
              ))
          
        :
        <tr>
          <td colSpan={7}>
              <Empty description={<>{`${filter.length > 0 ? `Nic nie znaleziono` : `Nie dodano jeszcze rodzica`}`}</>} className='my-4'/>
          </td>
        </tr>
        }
        </tbody>
      </Table>
      <Stack spacing={2} alignItems={isMobile ? "left" : "center"}  justifyContent="center">
        <Pagination count={count} defaultPage={1} page={page} boundaryCount={2} onChange={(e, v) => setPage(v)} size="large" variant="outlined" color="secondary"/>
      </Stack>
    </>
  )
}